// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yf1W","delete":"styles_delete__3PhTP","update":"styles_update__2L67U","add":"styles_add__3Rhq2"};